// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__GCSlT","title":"Info_title__XdpFY","links":"Info_links__x96nv","link":"Info_link__3X3Hv","logo":"Info_logo__2YMRP"};